import { cn } from "@/utils/cn";
import React from "react";

export const StatusScreen = React.memo(function StatusScreen(props: {
  emoji: string;
  title: string;
  subtitle: React.ReactNode;
  fullScreen?: boolean; // covers the full viewport instead of just filling its container
  children?: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        "flex w-full flex-col items-center justify-center gap-1 bg-surface px-6 py-8 text-center",
        props.fullScreen ? "fixed inset-0 z-9999 h-auto" : "h-screen"
      )}
    >
      <div className="mb-3 text-[56px] leading-none" aria-hidden="true">
        {props.emoji}
      </div>
      <h1 className="m-0 text-heading-lg/[inherit] font-bold text-title-color">
        {props.title}
      </h1>
      <p className="mx-0 mt-2 mb-7 max-w-80 text-body leading-5 text-text-muted">
        {props.subtitle}
      </p>
      <div className="flex w-full max-w-70 flex-col gap-3">
        {props.children}
      </div>
    </div>
  );
});
